import { useState } from "react";
import { HeartHandshake, CheckCircle2, BookHeart } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "../lib/api";
import { Input } from "./ui/input";
import { Textarea } from "./ui/textarea";
import { Label } from "./ui/label";
import { Button } from "./ui/button";

export default function DonationForm({ compact = false }) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [count, setCount] = useState("");
  const [note, setNote] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/donations", { name, email, book_count: parseInt(count, 10) || 1, note });
      setDone(true);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  if (done) {
    return (
      <div data-testid="donation-success" className="rounded-2xl border border-secondary/30 bg-secondary/10 p-6 text-center">
        <CheckCircle2 className="w-10 h-10 mx-auto text-secondary mb-3" />
        <h3 className="font-serif text-xl font-semibold">Grazie di cuore, {name.split(" ")[0] || "amico lettore"}!</h3>
        <p className="text-sm text-muted-foreground mt-2">La tua proposta di donazione è stata inviata al bibliotecario, che ti contatterà via email per organizzare la consegna dei libri.</p>
        <Button variant="outline" className="mt-4" data-testid="donation-again" onClick={() => { setDone(false); setName(""); setEmail(""); setCount(""); setNote(""); }}>Invia un'altra donazione</Button>
      </div>
    );
  }

  return (
    <form onSubmit={submit} data-testid="donation-form" className="rounded-2xl border border-border bg-card p-5 sm:p-6 space-y-4">
      <div className={`grid gap-4 ${compact ? "" : "sm:grid-cols-2"}`}>
        <div>
          <Label htmlFor="dn">Il tuo nome</Label>
          <Input id="dn" data-testid="donation-name" required value={name} onChange={(e) => setName(e.target.value)} className="mt-1.5 h-11" />
        </div>
        <div>
          <Label htmlFor="de">Email</Label>
          <Input id="de" data-testid="donation-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5 h-11" />
        </div>
      </div>
      <div>
        <Label htmlFor="dc">Quanti libri vuoi donare? (circa)</Label>
        <Input id="dc" data-testid="donation-count" type="number" min="1" required value={count} onChange={(e) => setCount(e.target.value)} placeholder="Es. 10" className="mt-1.5 h-11" />
      </div>
      <div>
        <Label htmlFor="dnote">Nota <span className="text-muted-foreground font-normal">(facoltativa: generi o titoli)</span></Label>
        <Textarea id="dnote" data-testid="donation-note" value={note} onChange={(e) => setNote(e.target.value)} rows={3} className="mt-1.5" placeholder="Es. romanzi, gialli, alcuni libri per bambini…" />
      </div>
      <Button type="submit" data-testid="donation-submit" disabled={loading} className="w-full h-11 bg-secondary hover:bg-secondary/90 text-secondary-foreground">
        <HeartHandshake className="w-4 h-4 mr-2" />{loading ? "Invio…" : "Dona i tuoi libri"}
      </Button>
    </form>
  );
}
